import { useMutation } from 'react-query'

import { type ContactUsPersistence } from '../../../../types/persistence/contact-us-persistance'
import { api } from '../../../api'

const contactUs = async (body: ContactUsPersistence) => {
  const response = await api.post('/mail/contact-us', body)
  return response.data
}

export const useContactUsMutation = () => {
  return useMutation('contact-us', {
    mutationFn: (body: ContactUsPersistence) => {
      return contactUs(body)
    },
  })
}
